import { useSignUpMutation } from "@/queries/Auth";

export function useLoginService() {
  return useSignUpMutation();
}
